const messages = {
  advice: 'Hemos apartado tu cita por:',
  expired: 'Se agoto el tiempo, por favor selecciona otro horario'
}

export default messages
